module.exports = __webpack_public_path__ + "media/images/common/order_btn_s-2cfac8cad6291b6fcd2082babca755d8.png";